type ServiceAccount = { id: string; name: string; disabled: boolean | null };

type Grant<S extends ServiceAccount> = {
  serviceAccountId: string | null;
  builtinRoleId: string | null;
  customRoleId: string | null;
  scopeId: string;
  serviceAccount: S | null | undefined;
};

export type ServiceAccountWithScopes<S> = {
  serviceAccount: S;
  scopeIds: string[];
};

export function findServiceAccountsForRole<S extends ServiceAccount>(
  grants: readonly Grant<S>[],
  roleId: string,
  isBuiltin: boolean
): ServiceAccountWithScopes<S>[] {
  const byAccount = new Map<
    string,
    { serviceAccount: S; scopeIds: string[]; seen: Set<string> }
  >();
  for (const g of grants) {
    const matches = isBuiltin
      ? g.builtinRoleId === roleId
      : g.customRoleId === roleId;
    if (!matches || !g.serviceAccountId || !g.serviceAccount) continue;
    if (g.serviceAccount.disabled) continue;
    let entry = byAccount.get(g.serviceAccountId);
    if (!entry) {
      entry = {
        serviceAccount: g.serviceAccount,
        scopeIds: [],
        seen: new Set(),
      };
      byAccount.set(g.serviceAccountId, entry);
    }
    if (entry.seen.has(g.scopeId)) continue;
    entry.seen.add(g.scopeId);
    entry.scopeIds.push(g.scopeId);
  }
  return [...byAccount.values()].map(({ serviceAccount, scopeIds }) => ({
    serviceAccount,
    scopeIds,
  }));
}
